import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class GridService {
  resize$ = new Subject();

  resize() {
    this.resize$.next(true);
  }
}
